query sportsAndCompetitions($sports: [UUID!], $searchValue: String = "", $includeCompetitions: Boolean!) {
  sports: allSports(orderBy: SPORT_NAME_ASC, condition: { limbo: false }) {
    nodes {
      sportId
      sportName
    }
  }
  competitions: allCompetitions(
    first: 10
    orderBy: COMPETITION_NAME_ASC
    condition: { limbo: false }
    filter: {
      competitionName: { includesInsensitive: $searchValue }
      sportId: { in: $sports }
    }
  ) @include(if: $includeCompetitions) {
    nodes {
      competitionId
      competitionName
      sportId
    }
  }
}